<template>
  <slot></slot>
</template>

<script setup lang="ts">
</script>
 